import React, { useRef, useState } from "react"
import ContentLayoutHeader from "../../../components/layouts/ContentLayoutHeader.layout"
import MyProjects from "./myProjects/MyProjects.controller"
import PrimaryButton from "../../../components/molecules/buttons/PrimaryButton.molecule"
import { ReactComponent as QuestionMarkIcon } from "../../../design/assests/images/icons/question_mark.svg"
import useScreenDimensionsContext from "../../../hooks/contextConsumers/useScreenDimensionsContext.hook"
import { BREAKPOINTS } from "../../../consts/responsiveBreakpoints.consts"
import { clsx } from "../../../utils/strings.utils"
import CustomDialog from "../../../components/molecules/CustomDialog.molecule"
import { OverlayPanel } from "../../../components/atoms/OverlayPanel.atom"

const TimeRegisterHeader = ({ setRefreshProjects, initTutorial }) => {
  const myProjectsOverlayRef = useRef(null)
  const [isMobileMyProjectsOpen, setIsMobileMyProjectsOpen] = useState(false)

  const { screenWidth } = useScreenDimensionsContext()
  const isMobile = screenWidth <= BREAKPOINTS.MOBILE_BREAKPOINT

  return (
    <>
      <ContentLayoutHeader
        title="Registro diario"
        buttonProps={{
          label: isMobile ? "" : "Mis proyectos",
          icon: "pi pi-briefcase",
          className: clsx("h-fit my-projects-button", isMobile && "p-2"),
          onClick: (e) =>
            isMobile ?
              setIsMobileMyProjectsOpen(true)
            : myProjectsOverlayRef.current.show(e),
        }}
        extraContent={
          !isMobile && (
            <PrimaryButton
              onClick={() => initTutorial()}
              icon={<QuestionMarkIcon />}
              className="bg-secondary border-none tutorial-button w-3rem h-3rem text-white"
            />
          )
        }
      />
      {!isMobile && (
        <OverlayPanel
          dismissable={false}
          id="local-multiselect-dropdown-overlay"
          onHide={() => myProjectsOverlayRef.current.hide()}
          ref={myProjectsOverlayRef}
        >
          <MyProjects
            onAccept={() => {
              setRefreshProjects((prev) => !prev)
              myProjectsOverlayRef.current.hide()
            }}
            onCancel={() => {
              myProjectsOverlayRef.current.hide()
            }}
          />
        </OverlayPanel>
      )}
      {isMobile && (
        <CustomDialog
          dismissableMask
          visible={isMobileMyProjectsOpen}
          className="mobile-general-report-filters-dialog"
          onHide={() => {
            setIsMobileMyProjectsOpen(false)
            // setFilteredUsersBuffer(filteredUsers)
          }}
          withoutDivider
          withoutHeader
          withoutFooter
        >
          <MyProjects
            onAccept={() => {
              setRefreshProjects((prev) => !prev)
              setIsMobileMyProjectsOpen(false)
            }}
            onCancel={() => {
              setIsMobileMyProjectsOpen(false)
            }}
          />
        </CustomDialog>
      )}
    </>
  )
}

export default TimeRegisterHeader
